import { render, staticRenderFns } from "./settings-card.vue?vue&type=template&id=79cc72f5&scoped=true&"
import script from "./settings-card.vue?vue&type=script&lang=js&"
export * from "./settings-card.vue?vue&type=script&lang=js&"
import style0 from "./settings-card.vue?vue&type=style&index=0&id=79cc72f5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc72f5",
  null
  
)

export default component.exports